<template>
  <div class="space-ba-xxl" id="publikationen">
    <!-- <h2 class="space-ba-xs">Publikationen</h2> -->

    <!-- EINLEITUNG -->
    <div class="space-ba-s" v-html="newLineText(entries.einleitungPublikationen)"></div>

    <!-- PUBLIKATIONEN -->
    <div class="border-b" :class="{'border-t': i == 0}" v-for="(item, i) in entries.publikationen" :key="i">
      <div class="publikationen type-xs" v-html="newLineText(item.bibliografischeAngabe)"></div>
    </div>

  </div>
</template>

<script>
export default {
  name: "Publikationen",
  props: {
    entries: Object,
  },
  data() {
    return {};
  },
  methods: {
    newLineText(el) {
      if(el){
        return el.replace(/(?:\r\n|\r|\n)/g, "<br />");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.publikationen {
  padding-top: 1.6rem;
  padding-bottom: 1.5rem;
}

</style>

